var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "rounded-pill py-2 pl-2 pr-3 text-nowrap",
      class: [_vm.value ? "has" : "no-has"]
    },
    [
      _c("span", { staticClass: "fa-stack" }, [
        _c("i", { staticClass: "fas fa-circle fa-stack-2x" }),
        _c("i", {
          staticClass: "fas fa-stack-1x",
          class: {
            "fa-check": _vm.value,
            "fa-times": !_vm.value
          }
        })
      ]),
      _vm._v(
        " " +
          _vm._s(
            _vm.value
              ? _vm.trueText ?? _vm.text
              : _vm.falseText ?? ` No ${_vm.text}`
          ) +
          " "
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }